import { createAction } from 'redux-actions';

const actions = {
  /**
   *  데이터 변경하기
   */
  SET_DATA: 'searchWord/SET_DATA',
  setData: createAction('searchWord/SET_DATA'),

  /**
   *  [검색 키워드 리스트] 리스트 요청하기
   */
  GET_SEARCH_WORD_LIST_REQUEST: 'searchWord/GET_SEARCH_WORD_LIST_REQUEST',
  GET_SEARCH_WORD_LIST_SUCCESS: 'searchWord/GET_SEARCH_WORD_LIST_SUCCESS',
  getSearchWordList: createAction('searchWord/GET_SEARCH_WORD_LIST_REQUEST'),

  /**
   *  [검색 키워드 리스트] 엑셀 다운로드 요청하기
   */
  GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST: 'searchWord/GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSearchWordListExcelDownload: createAction('searchWord/GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  검색 키워드 상세 요청하기
   */
  GET_SEARCH_WORD_DETAIL_REQUEST: 'searchWord/GET_SEARCH_WORD_DETAIL_REQUEST',
  GET_SEARCH_WORD_DETAIL_SUCCESS: 'searchWord/GET_SEARCH_WORD_DETAIL_SUCCESS',
  getSearchWordDetail: createAction('searchWord/GET_SEARCH_WORD_DETAIL_REQUEST'),

  /**
   *  키워드 체크하기
   */
  CHECK_KEYWORD_REQUEST: 'searchWord/CHECK_KEYWORD_REQUEST',
  CHECK_KEYWORD_SUCCESS: 'searchWord/CHECK_KEYWORD_SUCCESS',
  checkKeyword: createAction('searchWord/CHECK_KEYWORD_REQUEST'),

  /**
   *  검색 키워드 등록하기
   */
  CREATE_SEARCH_WORD_REQUEST: 'searchWord/CREATE_SEARCH_WORD_REQUEST',
  createSearchWord: createAction('searchWord/CREATE_SEARCH_WORD_REQUEST'),

  /**
   *  검색 키워드 편집하기
   */
  EDIT_SEARCH_WORD_REQUEST: 'searchWord/EDIT_SEARCH_WORD_REQUEST',
  editSearchWord: createAction('searchWord/EDIT_SEARCH_WORD_REQUEST'),

  /**
   *  검색 키워드 삭제 요청하기
   */
  DELETE_SEARCH_WORD_REQUEST: 'searchWord/DELETE_SEARCH_WORD_REQUEST',
  deleteSearchWord: createAction('searchWord/DELETE_SEARCH_WORD_REQUEST'),

  /**
   *  연관 키워드 리스트 요청하기
   */
  GET_RELATED_SEARCH_WORD_LIST_REQUEST: 'searchWord/GET_RELATED_SEARCH_WORD_LIST_REQUEST',
  GET_RELATED_SEARCH_WORD_LIST_SUCCESS: 'searchWord/GET_RELATED_SEARCH_WORD_LIST_SUCCESS',
  getRelatedSearchWordList: createAction('searchWord/GET_RELATED_SEARCH_WORD_LIST_REQUEST'),
};

export default actions;
